import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSession } from '@descope/react-sdk';

export function ProtectedRoute() {
  const { isAuthenticated, isSessionLoading } = useSession();
  const location = useLocation();

  // Don't redirect during session hydration — avoids a flash to /login on page reload.
  if (isSessionLoading) return null;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <Outlet />;
}
